import { render, staticRenderFns } from "./ResultPopup.vue?vue&type=template&id=36166fd0&scoped=true&"
import script from "./ResultPopup.vue?vue&type=script&lang=js&"
export * from "./ResultPopup.vue?vue&type=script&lang=js&"
import style0 from "./ResultPopup.vue?vue&type=style&index=0&id=36166fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36166fd0",
  null
  
)

export default component.exports